<button (click)="onClick(-1)" [disabled]="pageIndex === 0" class="icon icon-menu icon-arrow-previous"></button>

<div class="text">{{ pageIndex + 1 }} / {{ totalPages }}</div>

<button (click)="onClick(1)" [disabled]="pageIndex === totalPages - 1" class="icon icon-menu icon-arrow-next"></button>
